<template>
  <div class="order-summary">
    <h2
      class="block-title"
      v-t="'order.summary'"
    />
    <div class="text-box">
      <div class="text-item">
        <div
          class="text-label"
        >
          {{ showNumber }}
        </div>
        <div class="text-value">
          {{ (this.isTaiwanClient ? detail.ali_order_no : detail.order_no) || detail.order_no }}
          <a
            v-if="detail.contract_url && !isMiniProgram"
            class="download-link"
            target="_blank"
            :href="
              detail.ali_order_no
                ? `${apiBaseUrl}/mall/contract/preview-ali?ali_order_no=${detail.ali_order_no}`
                : detail.contract_url
            "
          >
            <mm-icon name="download" />
            <span v-t="'order.download[0]'" />
          </a>
          <template v-if="!isTaiwanClient">
            <a
              v-if="detail.sales_proof_url && !isMiniProgram"
              class="download-link"
              target="_blank"
              :href="detail.sales_proof_url"
            >
              <mm-icon name="download" />
              <span v-t="'order.download[3]'" />
            </a>
          </template>
          <a
            v-if="detail.other_url && !isMiniProgram"
            class="download-link"
            target="_blank"
            :href="detail.other_url"
          >
            <mm-icon name="download" />
            <span v-t="'order.download[1]'" />
          </a>
        </div>
      </div>
      <div class="text-item">
        <div
          class="text-label"
          v-t="'order.aliOrderNo'"
        />
        <div class="text-value">
          {{ detail.ali_order_no }}
        </div>
      </div>
      <div class="text-item">
        <div
          class="text-label"
          v-t="'order.company'"
        />
        <div class="text-value">
          {{ detail.full_name }}
        </div>
      </div>
      <div class="text-item">
        <div
          class="text-label"
          v-t="'order.totalAmount'"
        />
        <div class="text-value">
          {{ currency }}{{ detail.original_amount }}
        </div>
      </div>
      <div class="text-item">
        <div
          class="text-label"
          v-t="'order.discountAmount'"
        />
        <div class="text-value">
          {{ currency }}{{ detail.discount_amount }}
        </div>
      </div>
      <!-- 已支付订单不显示应付金额 -->
      <div 
        class="text-item" 
        v-if="Number(detail.status) !== ORDER_STATUS_COMPLETE"
      >
        <div
          class="text-label"
          v-t="'order.amount[1]'"
        />
        <div class="text-value">
          {{ currency }}{{ detail.amount }}
        </div>
      </div>
      <div class="text-item">
        <div
          class="text-label"
          v-t="'order.paidAmount'"
        />
        <div class="text-value">
          {{ currency }}{{ detail.paid_amount }}
        </div>
      </div>
      <!-- 已支付订单显示已退款 -->
      <div 
        class="text-item" 
        v-if="Number(detail.status) === ORDER_STATUS_COMPLETE"
      >
        <div
          class="text-label"
          v-t="'order.refund'"
        />
        <div class="text-value">
          {{ currency }}{{ detail.refund_amount }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

import Servers from "@config";
import { ORDER_STATUS_COMPLETE } from "@/utils/constants";

export default {
  name: "OrderSummary",
  computed: {
    ...mapState("order", {
      detail: state => state.detail
    }),
    ...mapGetters("order", ["currency"]),
    ...mapGetters("main", ["isMiniProgram", "isAliUser", "aliOrderInvoiceHide", "isTaiwanClient"]),
    showNumber() {
      if (this.isTaiwanClient) {
        return 'Alibaba订单';
      }
      return this.$t('order.number')
    },
  },
  data() {
    return {
      apiBaseUrl: Servers.oss,
      ORDER_STATUS_COMPLETE,
    };
  },
};
</script>
<style lang="scss" scoped>
.order-summary {
  padding-top: 20px;
  border-top: 2px solid #d9d9d9;
}
</style>
